module.exports = __webpack_public_path__ + "static/media/quieromibarrio4.136400f7.jpg";